var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMaster)?_c('div',[_c('base-item-group',{attrs:{"item":_vm.items}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }